import { CSSTransition } from "react-transition-group";
import classes from './Backdrop.module.scss'
import { createRef } from "react";

const animationClasses = {
    enter: classes["fade-enter"],
    enterDone: classes["fade-enter-active"],
    exit: classes["fade-exit"],
    exitDone: classes["fade-exit-active"]
}

const animationTiming = {
    enter: 0,
    exit: 300
}

// className: lets a caller lift the backdrop (z-index) above its own overlays.
const BackDrop = ({ show, clicked, className }) => {

    const nodeRef = createRef(null);

    return (
        <CSSTransition in={show} nodeRef={nodeRef} unmountOnExit timeout={animationTiming} classNames={animationClasses} >
            <div ref={nodeRef} onClick={clicked} className={className ? `${classes.BackDrop} ${className}` : classes.BackDrop} ></div>
        </CSSTransition>
    )
}

export default BackDrop;
